import { useState } from "react"
import useParams from "../../../services/helpers/custom_hook/paramsUrl";

function Pagination({ countPage, page, setPage, gfilter, setgfilter }) {
  const [setParamsUrl, setFiltersFromUrl] = useParams();

  const [visibility, setVisibility] = useState({
    previus: 'visible',
    next: 'visible'
  })

  const newPage = {
    'previus': () => { return page - 1 },
    'next': () => { return page + 1 },
    'first': () => { return page },
    'second': () => { return page + 1 },
    'third': () => { return page + 2 }
  }

  const previusPage = (actionPage) => {
    let pageg = page >= newPage[actionPage]() && page >= 1 ? newPage[actionPage]() : page
    setPage(pageg)
    newPage[actionPage]() >= countPage ? setVisibility({ ...visibility, next: 'invisible' }) : setVisibility({ ...visibility, next: 'visible' })
    setgfilter({ ...gfilter, pageg })
    setParamsUrl({ ...gfilter, pageg })
  }

  const nextPage = (actionPage) => {
    let pageg = newPage[actionPage]() <= countPage ? newPage[actionPage]() : page
    setPage(pageg)
    newPage[actionPage]() >= countPage ? setVisibility({ ...visibility, next: 'invisible' }) : setVisibility({ ...visibility, next: 'visible' })
    setgfilter({ ...gfilter, pageg })
    setParamsUrl({ ...gfilter, pageg })
  }
  const changePage = (actionPage) => {
    let pageg = newPage[actionPage]()
    setPage(pageg)
    setgfilter({ ...gfilter, pageg })
    setParamsUrl({ ...gfilter, pageg })
  }

  return (
    <nav className='justify-center mt-4' aria-label="Page navigation example">
      <ul id="pagination" className="pagination bg-transparent">
        {page > 1 &&
          <li className=" page-item">
          <button onClick={() => previusPage('previus')} className="no-border p-2 bg-transparent" href="#" aria-label="Previous">
            <i className="fas fa-chevron-left"></i>
            </button>
          </li>
        }
        {page <= countPage &&
          <li className={visibility.first + " page-item"}>
          <button onClick={() => changePage('first')} className="no-border p-2 bg-transparent" href="#"><h3 className='family-bold'>{page}</h3></button>
          </li>
        }
        {page < countPage &&
          <li className={visibility.second + " page-item"}>
          <button onClick={() => changePage('second')} className="no-border p-2 bg-transparent" href="#"><h3>{page + 1}</h3></button>
          </li>
        }
        {page + 1 < countPage &&
          <li className={visibility.third + " page-item"}>
          <button onClick={() => changePage('third')} className="no-border p-2 bg-transparent" href="#"><h3>{page + 2}</h3></button>
          </li>
        }
        {page <= countPage &&
          <li className={visibility.next + " page-item"}>
          <button onClick={() => nextPage('next')} className="no-border p-2 bg-transparent" href="#" aria-label="Next">
            <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        }
      </ul>
    </nav>
  )
}

export default Pagination
